import { FC } from 'react';

// https://dev.to/
const Close: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="img"
      aria-labelledby="aaycyq932r4wf3k69e4b59zwnne6c612"
      aria-hidden="true"
    >
      <title id="aaycyq932r4wf3k69e4b59zwnne6c612">Close</title>
      <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636l4.95 4.95z"></path>
    </svg>
  );
};

export default Close;
